<template>
  <div class="">
    <div class="head-title">客户管理</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>1、统计企业下员工的客户总数，客户归属于哪个员工及详情信息。</p>
          <p>
            2、管理员可对客户的标签设置进行更改，便于企业精细化分类管理客户。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <div style="margin-right: 2.4rem">
            <el-button type="primary" icon="el-icon-refresh" :loading="updateLoading" @click="getRenew">{{ loadingText
            }}</el-button>
          </div>
          <div style="margin-right: 2.4rem">
            <el-button type="primary" @click="kehu">客户统计</el-button>
          </div>
          <div @click="openDrawer()">
            <el-input placeholder="请选择成员" prefix-icon="el-icon-search" style="width: 15.0rem; margin: 0 .0rem 0 2.0rem"
              v-model="originUser">
            </el-input>
          </div>
          <el-input clearable placeholder="请输入客户昵称或标签" prefix-icon="el-icon-search"
            style="width: 27.0rem; margin: 0 .0rem 0 2.0rem" v-model="input2" @change="rune()">
          </el-input>
          <el-button slot="append" @click="rune()" type="primary">查询</el-button>
        </div>
        <div class="navbar-r"></div>
        <!---<div  @click="exportExcel"><exportExcel></exportExcel></div>-->

        <el-button plain class="download" @click="exportExcel" type="primary">
          <i class="el-icon-download"></i>
          <a :href="load" :download="load" style="color: white">导出</a>
        </el-button>
      </nav>
      <div>
        <el-table border  id="kuhutable" :data="tableData.data" v-loading="tableLoading">
          <el-table-column prop="name" label="客户昵称" style="width:10%"></el-table-column>
          <el-table-column prop="avatar" label="客户头像" style="width:10%">
            <template slot-scope="scope">
              <el-image style="width: 3.0rem; height: 3.0rem" :src="scope.row.avatar" :preview-src-list="[scope.row.avatar]"
                fit="scale-down"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="userid_name" label="归属成员" style="width:10%"></el-table-column>
          <el-table-column prop="gender" label="性别" style="width:10%"></el-table-column>
          <el-table-column prop="type" label="类型" style="width:10%"></el-table-column>
          <el-table-column label="添加状态" style="width:10%">
            <template slot-scope="scope">
              <!-- <div v-if="scope.row.status == '正常'" style="color: green">
                {{ scope.row.status }}
              </div>
              <div v-else-if="scope.row.status == '被客户删除'" style="color: red">
                {{ scope.row.status }}
              </div>
              <div v-else style="color: #e6a23c">
                {{ scope.row.status }}
              </div> -->
              <el-tag v-if="scope.row.status == '正常'" type="success" size="mini">{{ scope.row.status }}</el-tag>
              <el-tag v-else-if="scope.row.status == '被客户删除'" type="danger"  size="mini">{{ scope.row.status }}</el-tag>
              <el-tag v-else type="warning"  size="mini">{{ scope.row.status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="label" label="标签" style="width:10%">
            <template slot-scope="scope">
              <el-popover placement="left" trigger="hover">
                <template>
                  <div class="set-popper" v-html="scope.row.label"></div>
                </template>
                <div slot="reference">
                  <div v-if="scope.row.label == '暂无'">
                    {{ scope.row.label }}
                  </div>
                  <div v-else class="set-content">
                    <el-tag size="mini" style="margin: .2rem" v-for="(i, index) in scope.row.label" :key="index">{{ i
                    }}</el-tag>
                  </div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="描述" show-overflow-tooltip style="width:10%">
            <template slot-scope="scope">
              <div class="cont">
                {{ scope.row.description }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="备注" show-overflow-tooltip style="width:10%">
            <template slot-scope="scope">
              <div class="cont">
                {{ scope.row.remark }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" style="width:10%">
            <template slot-scope="scope">
              <el-button class="label-set-btn" @click="onTagDialog(scope.row)" size="mini" type="text">标签设置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <pagination :total="tableData.total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
        :page-sizes="[10, 20, 50, 100]" :auto-scroll="false" @pagination="userTable" />
    </div>
    <el-dialog title="添加" center :visible.sync="onSubmit" width="30%">
      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="添加" prop="name">
          <el-input clearable v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" center :visible.sync="onSubmitn" width="30%">
      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="名称" prop="none">
          <el-input clearable v-model="bianjile">{{ bianjile }}</el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 标签设置 -->
    <el-dialog title="请选择标签" center :visible.sync="dialogTableVisible">
      <div v-for="item of tags" :key="item.group_id" class="tag-item">
        <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll" @change="handleCheckAllChange(item)">{{
          item.group_name }}</el-checkbox>
        <div style="margin: 1.5rem 0"></div>
        <el-checkbox-group v-model="item.checkedCities" @change="handleCheckedCitiesChange(item)">
          <el-checkbox v-for="city in item.child" :label="city" :key="city.tag_id">{{ city.tag_name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addLoading" @click="offDialog">确 定</el-button>
      </span>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';
//import exportExcel from '../../components/exportExcel/index.vue'
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
export default {
  name: "adminManagement",
  inject: ["reload"],
  components: {
    Pagination,
    rightPeople
    /*
    exportExcel,*/
  },
  data() {
    return {
      checkbox: false,
      tableData: {
        total: 0,
        data: [],
      },
      addLoading: false,
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      dialogTableVisible: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      pageSize: "",
      tags: [],
      external_userid: 0,
      userid: "",
      group_label: [],
      listQuery: {
        page: 1,
        limit: 20,
      },
      source: null,
      updateLoading: false,
      loadingText: "同步客户",
      load: "",
      lianjie: "https://",
      module: "", //address组件执行哪个接口字段
      originUser: "", //选择成员搜索字段
      originUserId: "", //选择成员搜索的userid
      group_array: [],
      isAllSelect:{
        type: Boolean,
        default:false
      },
      tableLoading: true
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
    this.getDownLoad();
  },
  watch: {
    originUser() {
      if (this.originUser == "") {
        this.originUserId = "";
      }
      this.userTable();
    },
  },
  methods: {
    kehu() {
      window.location.href = "#/register/user/activeCodeTotal";
    },
    getDownLoad() {
      this.axios
        .post(
          "/crm/Assistant/adminManagementList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
            page: this.listQuery.page,
            download: "download",
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.code == 1) {
            const data = res.data;
            this.load = this.lianjie + data.data;
            //this.exportExcel();
          }
        });
    },
    async getRenew() {
      console.log(this.load);
      console.log(this.tableData);
      this.updateLoading = true;
      // 拉取更新数据
      const ws = new WebSocket("wss://api.weijub.com:4431");
      ws.onopen = () => {
        console.log("连接成功");
        this.loadingText = "数据拉取中";
        ws.send(
          JSON.stringify({
            uid: this.tooken.account_id,
            type: "getExternalcontactList2",
          })
        );
      };
      ws.onmessage = (e) => {
        // console.log("收到服务端的消息：" + JSON.stringify(e.data));
        this.updateLoading = false;
        this.loadingText = "同步客户";
        this.$message.success("同步成功");
        this.tableData.data = [];
        this.userTable();
      };
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    handleCheckAllChange(val) {
      const findItem = this.tags.find((item) => {
        return item.group_id === val.group_id;
      });
      findItem.checkedCities = val.checkAll ? findItem.child : [];
      findItem.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const findItem = this.tags.find((item) => {
        return item.group_id === value.group_id;
      });
      let checkedCount = value.checkedCities.length;
      findItem.checkAll = checkedCount === findItem.child.length;
      findItem.isIndeterminate =
        checkedCount > 0 && checkedCount < findItem.child.length;
    },
    async offDialog() {
      await this.addLabelUseAdmin();
      this.external_userid = "";
      this.userid = "";
      this.group_label = [];
    },
    onTagDialog(row) {
      this.external_userid = row.external_userid;
      this.userid = row.userid;
      this.group_label = row.group_label;
      this.dialogTableVisible = true;
      console.log(row,'rowrow')
      this.getLabelListUseAdmin();
    },
    addLabelUseAdmin() {
      this.addLoading = true;
      let group = this.tags.map((item) => {
        return {
          group_id: item.group_id,
          group_name: item.group_name,
          child: item.checkedCities,
        };
      });
      let group_label = group.filter((i) => {
        return i.child.length > 0;
      });
      this.group_array = JSON.stringify(group_label);
      this.axios
        .post(
          "/crm/Assistant/addLabelUseAdmin",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userid: this.userid,
            phone: this.tooken.phone,
            external_userid: this.external_userid,
            group: this.group_array,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
          if(res.data.code==1){
            this.$message({
              type:'success',
              message:res.data.msg,
            })
          }
          this.userTable();
          this.dialogTableVisible=false
          this.addLoading = false;

        })
        .catch(function (err) {
          //this.reload();
          this.dialogTableVisible=false
          this.userTable();
        });
    },
    //  页数
    handleCurrentChange(val) {
      let pageslimit = val;
      this.listQuery.limit = pageslimit.limit;
      this.pageSize = val;
      //console.log(this.listQuery.limit,"pagesize")
      this.userTable();
    },
    getLabelListUseAdmin() {
      this.axios
        .post(
          "/crm/Assistant/getLabelListUseAdmin",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          let data = res.data.data;

          data.map((item) => {
            item.checkAll = false;
            item.checkedCities = [];
            item.isIndeterminate = true;
          });
          if (this.group_label) {
            // 回显选中数据
            const group_label = JSON.parse(this.group_label);
            for (const d of data) {
              for (const g of group_label) {
                // 因为需要回显数据， 需要在全部数据内寻找与之对应的提交数据， 传递给全部数据中已选中字段checkedCities(已选中字段)
                if (d.group_name === g.group_name) {
                  // 由于全部数据checkedCities（已选中字段）只有与全部数据内的child相同才能回显选中效果，而提交后的child不行
                  // 因为提交的child对象虽然与全部数据对象内容一样，但两个对象是不相等的，它们并不是一个引用
                  // 对提交数据child与全部数据child比较，当相等时把全部数据的child相同条目传入checkedCities(已选中字段)
                  for (const c of g.child) {
                    for (const k of d.child) {
                      if (c.tag_name === k.tag_name) {
                        d.checkedCities.push(k);
                      }
                    }
                  }
                  let checkedCount = d.checkedCities.length;
                  d.checkAll = checkedCount === d.child.length;
                  d.isIndeterminate =
                    checkedCount > 0 && checkedCount < d.child.length;
                }
              }
            }
          }
          this.tags = data;
        })
        .catch(function (err) { });
    },
    /*需要添加一个字段 limit 来控制分页器的页数切换*/
    userTable(e) {
      this.axios
        .post(
          "/crm/Assistant/adminManagementList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
            userid: this.originUserId,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          res.data.data.data.forEach((i) => {
            let isTagEmpty;
            if (i.label) {
              isTagEmpty = i.label.includes("暂无");
            } else {
              i.label = "暂无";
              isTagEmpty = true;
            }
            i.isTagEmpty = isTagEmpty;
            if (!isTagEmpty) {
              i.label = i.label.split(",");
            }
          });
          this.tableLoading = false;
          this.tableData = res.data.data;
        })
        .catch((thrown) => { });
    },
    rune() {
      this.userTable();
      this.getDownLoad();
    },
    tianjia() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e, o) {
      this.yeshu = 1;
      this.ele = e;
      this.bianjile = o;
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/editSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.bianjile,
            id: this.ele,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },
    // 添加
    numoo() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/addSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/Source/delSource",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) { });
        })
        .catch(() => { });
    },
    //选择成员弹出组件
    openDrawer() {
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.originUser = person.name;
      this.originUserId = person.userid;
    },
    exportExcel() {
      // 1.生成Excel工作簿对象
      var wb = XLSX.utils.table_to_book(document.querySelector('#kuhutable'))
      if(this.isAllSelect){
        wb.Sheets.Sheet1['!cols'][9]={hidden:true}
      }
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        book: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(
          // Blob: 对象表示一个不可变 原始数据的类文件对象,不一定是JS原生格式的数据。
          // File: 基于Blob，继承了blob的功能并将其扩展使其支持用户系统上的文件。
          new Blob([wbout], { type: 'appliction/octet-stream' }),
          // 设置导出的文件名称可随意
          '客户管理列表.xls'
        )
      } catch (e) {
        //if (typeof console != 'undefined') console.log(e, wbout)
      }
      // 返回一个新创建的Blob对象，其内容由参数中给定的数组串联组成。
      return wbout
    }
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}

nav {
  width: 100%;
}

.shij {
  display: inline-block;
  margin-right: 2.4rem;
}

/* .download {
  margin-right: 6.5rem;
} */

.tag-item {
  margin-top: 3.2rem;
}

.tag-item:nth-child(1) {
  margin-top: 0;
}

.navbar {
  margin-bottom: 2.0rem;
}

.nav-l {
  display: flex;
}

.cont {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 3.0rem;
  font-size: 1.5rem;
}
</style>
